import { path } from 'ramda';
import { useSportsbookStore } from '../../store';

export const selectLineByKey = (lineKey) => path(['lines', lineKey]);

export const useLine = (lineKey) =>
  useSportsbookStore(selectLineByKey(lineKey));
